export default __webpack_public_path__ + "static/media/giveChances.50d1c413.png";